var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g(_vm._b({staticClass:"BTableCollectorPublications",attrs:{"selected":_vm.value,"headers":_vm.headers,"actions":_vm.actions,"list":_vm.list},scopedSlots:_vm._u([{key:"item.session",fn:function(ref){
var header = ref.header;
var item = ref.item;
var v = ref.value;
return [(header.getSessionNames)?_c('span',{domProps:{"textContent":_vm._s(header.getSessionNames(item, _vm.sessions))}}):[_vm._v(" "+_vm._s(v)+" ")]]}}])},'BTable',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }